import { useEffect, useState, useContext, useCallback } from 'react';
import { UserContext } from 'contexts/UserContext';

const useCustomerId = () => {
    const [customerId, setCustomerId] = useState(0);
    const { user } = useContext(UserContext);

    const getCustomerId = useCallback(() => {
        if (user.buyerType === 1 && user.cifs.length === 1) {
            return user.cifs[0].Id;
        }

        return user.preferredLocation && user.preferredLocation.ClientId
            ? user.preferredLocation.ClientId.toString()
            : null;
    }, [user.buyerType, user.cifs, user.preferredLocation]);

    useEffect(() => {
        setCustomerId(getCustomerId);
    }, [getCustomerId]);

    return customerId;
};

export default useCustomerId;
